import { render, staticRenderFns } from "./NoticeOfLoss.vue?vue&type=template&id=6946b198&scoped=true&"
import script from "./NoticeOfLoss.vue?vue&type=script&lang=ts&"
export * from "./NoticeOfLoss.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeOfLoss.vue?vue&type=style&index=0&id=6946b198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946b198",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VOverlay,VProgressCircular,VRow,VTab,VTabItem,VTabs})
